import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import Mint from 'mint-ui';
import 'mint-ui/lib/style.css';
import filter from './filters/index.js';
import './filters/preview.js';
import { install } from '@/utils/fatch.js';
import directive from './filters/directive.js';
import vueInit from './vue-init/init.js';
import Clipboard from 'vue-clipboard2';

Vue.config.productionTip = false;

// 引入mint-ui插件
Vue.use(Mint);
Vue.use(filter);
Vue.use(directive);
Vue.use(install);
Vue.use(vueInit);
Vue.use(Clipboard);

/* eslint-disable no-new */
Vue.prototype.$bus = new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App)
});
Vue.prototype.$messageBox = Mint.MessageBox;
Vue.prototype.$indicator = Mint.Indicator;
Vue.prototype.$toast = Mint.Toast;



// WEBPACK FOOTER //
// ./src/main.js